"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackEvents = exports.PrivateTrackEvents = exports.PublicTrackEvents = void 0;
exports.PublicTrackEvents = {
    VIDEO_IMPRESSION: 'vd_video_impression',
    VIDEO_FIRST_QUARTILE: 'vd_video_first_quartile',
    VIDEO_MIDPOINT: 'vd_video_midpoint',
    VIDEO_THIRD_QUARTILE: 'vd_video_third_quartile',
    VIDEO_COMPLETE: 'vd_video_complete',
    VIDEO_3_SECONDS: 'vd_video_3_seconds',
    VIDEO_6_SECONDS: 'vd_video_6_seconds',
    VIDEO_10_SECONDS: 'vd_video_10_seconds',
    VIDEO_30_SECONDS: 'vd_video_30_seconds',
    VIDEO_CTA_CLICK: 'vd_video_click_cta',
    VIDEO_LPM: 'vd_video_lpm',
    VIDEO_SEEK: 'vd_video_seek',
    // PIP
    VIDEO_PLAYER_QUIT: 'vd_player_quit',
    VIDEO_PLAYER_IMPRESSION: 'vd_player_impression',
    VIDEO_PLAYER_EXPAND: 'vd_player_expand',
    VIDEO_PLAYER_MINIMIZE: 'vd_player_minimize',
    VIDEO_PLAYER_MUTE: 'vd_player_mute_button_clicked',
    VIDEO_PLAYER_UNMUTE: 'vd_player_unmute_button_clicked',
    VIDEO_PLAYER_PLAY_BUTTON_CLICKED: 'vd_player_play_button_clicked',
    VIDEO_PLAYER_PAUSE_BUTTON_CLICKED: 'vd_player_pause_button_clicked',
    // STORY
    STORY_CIRCLE_TAPPED: 'vd_story_circle_tap',
    STORY_IMPRESSION: 'vd_story_impression',
    STORY_PLAYLIST_CLOSED: 'vd_story_playlist_closed',
    STORY_MUTE: 'vd_story_mute_button_clicked',
    STORY_UNMUTE: 'vd_story_unmute_button_clicked',
    // INLINE BUTTO_
    INLINE_BUTTON_IMPRESSION: 'vd_inline_button_impression',
    INLINE_BUTTON_EXPAND: 'vd_inline_button_click',
    // CAROUSEL
    CAROUSEL_IMPRESSION: 'vd_carousel_impression',
    CAROUSEL_EXPAND: 'vd_carousel_expand',
    // For client
    CLIENT_EXPERIMENTS_ADDED: 'vd_exps_added',
    // Landing Page
    LANDING_PAGE_IMPRESSION: 'vd_landing_page_impression',
    LANDING_PAGE_VIDEO_CONTAINER_CLICK: 'vd_landing_page_video_container_click',
    LANDING_PAGE_PRIMARY_CTA_CLICK: 'vd_landing_primary_cta_click',
    LANDING_PAGE_SECONDARY_CTA_CLICK: 'vd_landing_secondary_cta_click',
    LANDING_PAGE_PRODUCT_CARD_CLICK: 'vd_landing_product_card_click',
    LANDING_PAGE_MENU_ITEM_CTA_CLICK: 'vd_landing_menu_item_cta_click',
    LANDING_PAGE_MENU_ITEM_CLICK: 'vd_landing_menu_item_click',
    LANDING_PAGE_CART_PAGEVIEW: 'vd_landing_cart_pageview',
    LANDING_PAGE_PLP_PAGEVIEW: 'vd_landing_plp_pageview',
    LANDING_PAGE_PDP_PAGEVIEW: 'vd_landing_pdp_pageview',
    LANDING_PAGE_CLIENT_OUTBOUND_CLICK_PLP: 'vd_landing_plp_client_outbound_click',
    LANDING_PAGE_CLIENT_OUTBOUND_CLICK_PDP: 'vd_landing_pdp_client_outbound_click',
    LANDING_PAGE_PDP_IMAGE_CAROUSEL_SWIPE: 'vd_landing_pdp_image_carousel_swipe',
    LANDING_PAGE_CART_CONTINUE_CLICK: 'vd_landing_cart_continue_click',
    LANDING_PAGE_CART_QUANTITY_UPDATE: 'vd_landing_cart_quantity_update',
    LANDING_PAGE_CART_REMOVE_ITEM: 'vd_landing_cart_remove_item',
    LANDING_PAGE_CART_CHECKOUT_CLICK: 'vd_landing_cart_checkout_click',
    LANDING_PAGE_HEADER_CLICK: 'vd_landing_header_click',
    LANDING_PAGE_TAB_BAR_CLICK: 'vd_landing_tab_bar_click',
    LANDING_PAGE_STATIC_CAROUSEL_SWIPE: 'vd_landing_static_carousel_swipe',
    LANDING_PAGE_REVIEWS_SUMMARY_CLICK: 'vd_landing_reviews_summary_click',
    LANDING_PAGE_SEE_MORE_REVIEWS_CLICK: 'vd_landing_see_more_reviews_click',
    LANDING_PAGE_PDP_VIEW_ON_SITE_CLICK: 'vd_landing_pdp_view_on_site_click',
    LANDING_PAGE_PLP_VIEW_ON_SITE_CLICK: 'vd_landing_plp_view_on_site_click',
    LANDING_PAGE_PRODUCT_FILTER_BUTTON_CLICK: 'vd_landing_product_filter_button_click',
    LANDING_PAGE_PRODUCT_FILTER_SHOW_RESULTS_CLICK: 'vd_landing_product_filter_show_results_click',
    LANDING_PAGE_PRODUCT_FILTER_CLEAR_FILTERS_CLICK: 'vd_landing_product_filter_clear_filters_click',
    // Experiments
    EXPERIMENT_FAILURE: 'vd_experiment_failure',
    // "vd_video:session",
    // "vd_shopping:hydrate-products",
    // "vd_shopping:cart-updated",
    // "vd_shopping:request-checkout",
    // "vd_shopping:product-clicked",
    // "vd_embed-feed:impression",
    // "vd_embed-feed:thumbnail-load",
    // "vd_embed-feed:thumbnail-click",
};
exports.PrivateTrackEvents = {
    WATERMARK_CLICK: 'internal_vd_watermark_clicked',
    IDENTIFY_CLIENT: 'internal_vd_identify_client',
    BRAND_CHAT_OPEN: 'brand_chat_open',
    BRAND_CHAT_MESSAGE_SEND: 'brand_chat_message_send',
    BRAND_CHAT_PRODUCT_CLICK: 'brand_chat_product_click',
};
exports.TrackEvents = Object.assign(Object.assign({}, exports.PublicTrackEvents), exports.PrivateTrackEvents);
